import IconButton from '@mui/material/IconButton';
import IconClose from '../../../asset/icons/icon_close.svg';

export const DialogClose = ({onClose, disabled}: {onClose: () => void; disabled?: boolean}) => {
  return (
    <IconButton className='w-34' onClick={onClose} disabled={disabled}>
      <img src={IconClose} alt='close' />
    </IconButton>
  );
};
